<section *ngIf="loading">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading..."></mat-progress-bar>
</section>

<section *ngIf="!loading">
  <h2>
    <mat-icon>upload</mat-icon> Upload Test Results
  </h2>

  <!-- Saved -->
  <div fxLayout="row wrap" class="matero-row" *ngIf="!loading && saved == true">
    <br /><br />
    <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
      <mat-card>
        <span class="success">
          <mat-icon>done</mat-icon> The Bulk Upload was successful
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button mat-raised-button color="primary" (click)="resetUpload()" title="Upload more Test Results">Upload more
            Test Results</button>
        </span>
      </mat-card>
      <mat-card *ngIf="bulkUploadSampleList.length > 0">
        <div fxLayout="row wrap" class="matero-row">
          <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col">
            <strong class="noMarginHeader">Saved Bulk Upload ({{bulkUploadSampleList.length}})</strong>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <mat-form-field style="width:200px;">
              <input (keyup)="filterTable($event)" placeholder="Filter Results" matInput />
            </mat-form-field>
            <br />
            <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8">
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              <ng-container matColumnDef="sampleId">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Sample Id</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  <a href="javascript:void(0)" (click)="editSample(result.sampleId)"
                    title="Edit Sample {{result.sampleId}}">{{result.sampleId}}</a>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="wellId">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Well Id</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  <a [routerLink]="['/well/edit', result.wellId]"
                  title="Edit Well {{result.wellId}}">{{result.wellId}}</a>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="voucherId">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Voucher Id</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  <a href="javascript:void(0)" (click)="editVoucher(result.voucherId)"
                  title="Edit Voucher {{result.voucherId}}">{{result.voucherIdentifier}}</a>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="numberOfTests">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Number of <br />Test Results</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.numberOfTests}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="sampleDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Sample Date</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.sampleDate}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="analysisDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Analysis Date</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.analysisDate}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="createdDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.createdDate}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="testType">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Test Type</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.testType}}
                </mat-cell>
              </ng-container>
            </mat-table>
            <br />
            <mat-paginator [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator"
              showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </mat-card>
    </div>
  </div>

  <mat-horizontal-stepper [linear]="isLinear" #stepper labelPosition="bottom" *ngIf="!loading && saved == false">
    <!-- Lab -->
    <mat-step label="Add">
      <h4 style="margin-bottom:0px;">Select Post-Treatment, ReTest, Voucher Type and Organization</h4>
      <br />
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <input
                  type="checkbox"
                  [checked]="postTreatment"
                  (change)="postTreatment = !postTreatment"/> Post-Treatment? <br /> 
                  <div>
                    <mat-form-field style="width:375px !important" [hidden]="postTreatment == false">
                      <br />
                      <mat-label><br />Would you like to associate this upload to a treatment?</mat-label>
                      <mat-select [(ngModel)]="associateTreatmentPlan" 
                        (selectionChange)="associateTreatmentPlanChange(selectField2.value);"
                        #selectField2 matNativeControl>
                        <mat-option value="Yes">Yes</mat-option>
                        <mat-option value="No">No</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
              </div>
            </div>
            <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid" [hidden]="postTreatment == true">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <input
                  type="checkbox"
                  [checked]="isRetest"
                  (change)="isRetest = !isRetest"/> Is ReTest? <br />
              </div>
            </div>
            <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <mat-form-field style="width:375px !important">
                  <mat-label>Sample Origin</mat-label>
                  <mat-select [(ngModel)]="sampleOrigin" (selectionChange)="sampleOriginChange(selectField3.value);"
                    #selectField3 matNativeControl>
                    <mat-option *ngFor="let item3 of oregonWellDataService.originList" value="{{item3}}">
                      {{item3}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <mat-form-field style="width:375px !important">
                  <mat-label>Voucher Type</mat-label>
                  <mat-select [(ngModel)]="voucherType" (selectionChange)="voucherTypeChange(selectField1.value);"
                    #selectField1 matNativeControl>
                    <mat-option *ngFor="let item of voucherService.voucherTypesForUploadResults" value="{{item}}">
                      {{item}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <mat-form-field style="width:375px !important">
                  <mat-label>Organization</mat-label>
                  <input type="text" placeholder="Search Organization Name" aria-label="Organization Name" matInput
                  [formControl]="labsControl" [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option *ngFor="let option of filteredLabs | async" [value]="option.labName" (onSelectionChange)="labChange(option.id)">
                    {{option.labName}}
                  </mat-option>
                </mat-autocomplete>
                </mat-form-field>
                <br /><br />
                <ul style="list-style: inside;padding-left: 0;">
                  <li>The file will be for one Organization only</li>
                  <li>You will only be allowed to upload CSV or TXT files</li>
                  <li>CSV and TXT files need to be separated by a comma</li>
                  <li>The header row needs to be the first non-empty row in the file</li>
                  <li *ngIf="wellId > 0 || uploadType == voucherService.wellUploadType">
                    The file will be for one Well only. Your Well selection will be on the next screen
                  </li>
                  <li *ngIf="uploadType == voucherService.voucherUploadType">
                    The file must contain a column for the Voucher Ids. Multiple are allowed
                  </li>
                </ul>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <br />
      <div fxLayout="row wrap" class="matero-row">
        <span>&nbsp;&nbsp;</span>
        <button mat-raised-button color="primary" matStepperNext title="Next"
          *ngIf="voucherType != '' && labDetailsId > 0">Next</button>
      </div>
    </mat-step>

    <!-- File -->
    <mat-step label="Upload File">
      <h4 style="margin-bottom:0px;">Upload File</h4>
      <br />
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload />
                <div class="file-upload">
                  <button mat-raised-button color="primary" class="upload-btn" (click)="fileUpload.click()"
                    [disabled]="filename != null && filename.length > 0">
                    Select File
                    <mat-icon>attach_file</mat-icon>
                  </button>
                </div>
                <span *ngIf="filename != null && filename.length > 0"><br /></span>
                <div fxLayout="row" fxLayoutGap="8px" *ngIf="filename != null && filename.length > 0">
                  <span style="font-size: large;">File:&nbsp;</span>
                  <span>{{ filename }}</span>&nbsp;<mat-icon color="warn" (click)="removeStagedFile()"
                    title="Delete {{ filename }}">delete</mat-icon>
                </div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <br />
      <div fxLayout="row wrap" class="matero-row">
        <span>&nbsp;&nbsp;</span>
        <button mat-raised-button color="accent" matStepperPrevious title="Back">Back</button>
        &nbsp;&nbsp;
        <button mat-raised-button color="primary" matStepperNext title="Next"
          [disabled]="filename == null || filename.length == 0 || !validFile">Next</button>
      </div>
    </mat-step>

    <!-- Map Columns -->
    <mat-step label="Map Columns">
      <h4 style="margin-bottom:0px;">Map Header Columns</h4>
      <br />
      <mat-card>
        <div fxLayout="row wrap" class="matero-row" *ngFor="let column of headerColumnMapping; let i = index;">
          <div fxFlex="25" fxFlex.lt-sm="100" class="matero-col">
            <span>{{column.desc}}</span>
          </div>
          <div fxFlex="25" fxFlex.lt-sm="100" class="matero-col">
            <mat-form-field>
              <mat-label>Select Header Column</mat-label>
              <select [(ngModel)]="column.headerIndex" matNativeControl>
                <option value="-1"></option>
                <option *ngFor="let item of header; let hIndex = index;" value="{{hIndex}}">
                  {{item}}
                </option>
              </select>
            </mat-form-field>
          </div>
        </div>
      </mat-card>
      <br />
      <div fxLayout="row wrap" class="matero-row">
        <span>&nbsp;&nbsp;</span>
        <button mat-raised-button color="accent" matStepperPrevious title="Back">Back</button>
        &nbsp;&nbsp;
        <button mat-raised-button color="primary" matStepperNext title="Next" (click)="parseData()"
          [disabled]="headerMappingsIncomplete()">Next</button>
      </div>
    </mat-step>

    <!-- Verify -->
    <mat-step label="Verify Data">
      <h4 style="margin-bottom:0px;">File Verification</h4>
      <br />
      <div fxLayout="row wrap" class="matero-row" *ngIf="showProgressBar == true">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <strong>Verifying File</strong>
          <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
          <br /><br />
        </div>
      </div>
      <mat-card *ngIf="showProgressBar == false && bulkUploadSampleList.length == 0 && fileVerified == false">
        <div fxLayout="row wrap" class="matero-row">
          <span class="error">
            <mat-icon>error</mat-icon> A File has not been uploaded to verify
          </span>
        </div>
      </mat-card>
      <mat-card
        *ngIf="showProgressBar == false && bulkUploadSampleList.length > 0 && fileVerified == true && hasError == false">
        <div fxLayout="row wrap" class="matero-row">
          <span class="success">
            <mat-icon>done</mat-icon> The File uploaded has been verified
          </span>
        </div>
      </mat-card>
      <mat-card
        *ngIf="showProgressBar == false && bulkUploadSampleList.length > 0 && fileVerified == true && hasError == true">
        <div fxLayout="row wrap" class="matero-row error" *ngIf="hasError">
          &nbsp; There were error(s) with the Bulk Upload File. Please fix each error by selecting the correct value
          from the drop down
        </div>
        <br /><br />
        <div fxLayout="row wrap" class="matero-row" *ngIf="hasError == true">
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col"><strong>Message</strong></div>
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col"><strong>Database Options</strong></div>
        </div>
        <div fxLayout="row wrap" class="matero-row" *ngFor="let sample of bulkUploadSampleList; let i = index;">
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" *ngIf="sample.analyteError == true">
            <br /><br />{{sample.analyteErrorMessage}}
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" *ngIf="sample.analyteError == true">
            <mat-form-field appearance="standard">
              <mat-label>Select Analyte</mat-label>
              <mat-select id="analyte{{i}}" name="analyte{{i}}" [(ngModel)]="sample.analyte" matNativeControl>
                <mat-option *ngFor="let item of oregonWellDataService.contaminants" value="{{item.value}}">
                  {{item.text}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" *ngIf="sample.methodError == true">
            <br /><br />{{sample.methodErrorMessage}}
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" *ngIf="sample.methodError == true">
            <mat-form-field appearance="standard">
              <mat-label>Select Method</mat-label>
              <mat-select id="method{{i}}" name="method{{i}}" [(ngModel)]="sample.method" matNativeControl>
                <mat-option *ngFor="let item of analyticalMethods" value="{{item.text}}">
                  {{item.text}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" *ngIf="sample.unitError == true">
            <br /><br />{{sample.unitErrorMessage}}
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" *ngIf="sample.unitError == true">
            <mat-form-field appearance="standard">
              <mat-label>Select Unit</mat-label>
              <mat-select id="unit{{i}}" name="unit{{i}}" [(ngModel)]="sample.unit" matNativeControl>
                <mat-option *ngFor="let item of oregonWellDataService.units" value="{{item.value}}">
                  {{item.text}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" *ngIf="sample.voucherIdError == true">
            <br /><br />{{sample.voucherIdErrorMessage}}
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" *ngIf="sample.voucherIdError == true">
            <mat-form-field appearance="standard">
              <mat-label>Select Voucher Id</mat-label>
              <mat-select id="voucherId{{i}}" name="voucherId{{i}}" [(ngModel)]="sample.voucherId" matNativeControl>
                <mat-option *ngFor="let item of voucherIds" value="{{item.text}}">
                  {{item.text}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </mat-card>
      <br />
      
      <div fxLayout="row wrap" class="matero-row" [hidden]="associateTreatmentPlan === 'No' || !postTreatment">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <strong>Available Treatments</strong>
          <br /><br />
          <div fxLayout="row wrap" class="matero-row" *ngIf="loadingTreatmentPlans == true">
            <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
              <strong>Loading Treatments</strong>
              <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
              <br /><br />
            </div>
          </div>
          <div [hidden]="loadingTreatmentPlans == true">
              <!-- Available treatment plans -->
              <a (click)="getTreatmentPlans()"  [hidden]="createNewTreatment == true"><mat-icon>refresh</mat-icon> </a>
              <mat-table [dataSource]="dataSourceTreatmentPlans" class="mat-elevation-z8" [hidden]="createNewTreatment == true">
                <mat-header-row *matHeaderRowDef="displayedColumnsTreatmentPlans"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumnsTreatmentPlans;"></mat-row>
                <ng-container matColumnDef="select">
                  <mat-header-cell *matHeaderCellDef >Select</mat-header-cell>
                  <mat-cell *matCellDef="let result">
                    <input type="radio" id="treatmentId" name="treatmentId"
                    value="{{result.treatmentId}}" (click)="onChangeSelectedTreatment(result.treatmentId)" />
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="treatmentId">
                  <mat-header-cell *matHeaderCellDef >Treatment Id</mat-header-cell>
                  <mat-cell *matCellDef="let result">
                    <a (click)="editTreatment(result.treatmentId, result.housingUnitId)"  *ngIf="result.treatmentId != null && result.treatmentId > 0"
                      title="Edit Treatment {{result.treatmentId}}">{{result.treatmentId}}</a>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="statusOfInstall">
                  <mat-header-cell *matHeaderCellDef >Status Of Install</mat-header-cell>
                  <mat-cell *matCellDef="let result">
                    {{result.statusOfInstall}}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="installedBy">
                  <mat-header-cell *matHeaderCellDef >Installed By</mat-header-cell>
                  <mat-cell *matCellDef="let result">
                    {{result.installedBy}}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="treatmentInstallCompletionDate">
                  <mat-header-cell *matHeaderCellDef >Install Completion Date</mat-header-cell>
                  <mat-cell *matCellDef="let result">
                    {{result.treatmentInstallCompletionDate}}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="latestFilterChangeDate">
                  <mat-header-cell *matHeaderCellDef >Latest Filter Change Date</mat-header-cell>
                  <mat-cell *matCellDef="let result">
                    {{result.latestFilterChangeDate}}
                  </mat-cell>
                </ng-container>
              </mat-table>            
          </div> 
        </div>
      </div>
      <div fxLayout="row wrap" class="matero-row" *ngIf="!showProgressBar">
        <span>&nbsp;&nbsp;</span>
        <button mat-raised-button color="accent" matStepperPrevious title="Back">Back</button>
        &nbsp;&nbsp;
        <button mat-raised-button color="primary" matStepperNext title="Next"
          (click)="getAnalyteDisplayName();">Next</button>
      </div>
    </mat-step>

    <!-- Review and Upload -->
    <mat-step label="Review &amp; Upload">
      <h4 style="margin-bottom:0px;">Final Review &amp; Upload</h4>
      <br />
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="25" fxFlex.lt-sm="100">
                <strong>Voucher Type</strong> <span
                  *ngIf="voucherType != null || voucherType.length != 0"><br />{{voucherType}}</span>
                <br /><br />
                <strong>Organization</strong> <span *ngIf="labName != null || labName.length != 0"><br />{{labName}}</span>
                <span *ngIf="labName == null || labName.length == 0" class="text-red-400"> No Organization selected</span>
                <br /><br />
                <strong>File</strong> <span *ngIf="filename != null || filename.length != 0"><br />{{filename}}</span>
                <span *ngIf="filename == null || filename.length == 0" class="text-red-400"> No File selected</span>
              </div>
              <div fxFlex="75" fxFlex.lt-sm="100">
                <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                  <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col"><strong>Mapped Header Column</strong></div>
                  <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col"><strong>Column</strong></div>
                </div>
                <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row"
                  *ngFor="let column of headerColumnMapping; let i = index;">
                  <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
                    <span *ngIf="column.headerIndex > -1">{{header[column.headerIndex]}}</span>
                    <span *ngIf="column.headerIndex == -1" class="text-red-400">No Mapped Header Column</span>
                  </div>
                  <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
                    <span>{{column.desc}}</span>
                  </div>
                </div>
              </div>
            </div>
          </mat-card>
          <mat-card *ngIf="bulkUploadSampleList.length > 0">
            <div fxLayout="row wrap" class="matero-row">
              <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col">
                <strong class="noMarginHeader">Data to Upload ({{bulkUploadSampleList.length}})</strong>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <mat-form-field style="width:200px;">
                  <input (keyup)="filterTable($event)" placeholder="Filter Results" matInput />
                </mat-form-field>
                <br />
                <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8">
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                  <ng-container matColumnDef="voucherId">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Voucher Id</mat-header-cell>
                    <mat-cell *matCellDef="let result">
                      {{result.voucherId}}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="samplePoint">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Sample Point</mat-header-cell>
                    <mat-cell *matCellDef="let result">
                      {{result.clientId}}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="analyte">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Analyte</mat-header-cell>
                    <mat-cell *matCellDef="let result">
                      {{result.analyteName}}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="sampleResult">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Sample Result</mat-header-cell>
                    <mat-cell *matCellDef="let result">
                      {{result.result}}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="sampleDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Sample Date</mat-header-cell>
                    <mat-cell *matCellDef="let result">
                      {{result.sampleDate}}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="analysisDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Analysis Date</mat-header-cell>
                    <mat-cell *matCellDef="let result">
                      {{result.analysisDate}}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="method">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Method</mat-header-cell>
                    <mat-cell *matCellDef="let result">
                      {{result.method}}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="testType">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Test Type</mat-header-cell>
                    <mat-cell *matCellDef="let result">
                      {{result.testType}}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="treatmentId">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Treatment Id</mat-header-cell>
                    <mat-cell *matCellDef="let result">
                      <span *ngIf="selectedTreatmentId > 0">{{selectedTreatmentId}}</span>
                    </mat-cell>
                  </ng-container>
                </mat-table>
                <br />
                <mat-paginator [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator"
                  showFirstLastButtons></mat-paginator>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <br />
      <div fxLayout="row wrap" class="matero-row">
        <span>&nbsp;&nbsp;</span>
        <button mat-raised-button color="accent" matStepperPrevious title="Back">Back</button>
        &nbsp;&nbsp;
        <button mat-raised-button color="primary" title="Upload" (click)="onSubmit()" [disabled]="labDetailsId <= 0"
          *ngIf="fileVerified == true">Upload</button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>

</section>